import { MutableRefObject, useEffect } from 'react';

// Hook
function useOnClickOutside(
  ref: MutableRefObject<HTMLUListElement | null> | MutableRefObject<HTMLDivElement | null>,
  handler: () => void
) {
  useEffect(
    () => {
      const listener = (event: any) => {
        // Do nothing if clicking ref's element or descendent elements
        if (!ref.current || ref.current.contains(event.target)) {
          return;
        }

        handler();
      };

      document.addEventListener('mousedown', listener);
      document.addEventListener('touchstart', listener);

      return () => {
        document.removeEventListener('mousedown', listener);
        document.removeEventListener('touchstart', listener);
      };
    },
    // Add ref and handler to effect dependencies
    [ref, handler]
  );
}

export default useOnClickOutside;
